import Selection from './Selection';

export default Selection;



// WEBPACK FOOTER //
// ./src/components/Selection/index.tsx